export const xp_base = [
  ['2019/2020款 P40 V40 P80 地形模块', '电子件'],
  ['XP 2020款 水泵驱动板(含外壳)', '电子件'],
  ['XP 2020离心喷头', '电子件'],
  ['XP 2020/2020 ST款 飞控主机', '电子件'],
  ['XP 2020/2020 ST款 A20电机（短线）', '电子件'],
  ['XP 2020/2020 ST款 A20电机（长线）', '电子件'],
  ['P20/P30/XP 2019/2020/2020 ST款 电调驱动板', '电子件'],
  ['XP 2020/2020 ST款 RTK模块', '电子件'],
  ['P20/P30 19/20款 P40 V40 P80 UPS模块', '电子件'],
  ['XP 2020 蠕动泵', '电子件'],
  ['XP 2020/2020 ST款 FOC电调', '电子件'],
  ['P80 XP多频RTK天线-R', '电子件'],
  ['P80 XP多频RTK天线-L', '电子件'],
  ['XP 2020/2020 ST款 HDLS模块', '电子件'],
  ['P20/P30 2019/2020款 XP 2020款 航灯', '电子件'],
  ['XP 2020  XP 2020 ST款 航灯喷头连接线（长）', '电子件'],
  ['P80 XP双频天线-R', '电子件'],
  ['P80 XP 双频天线-L', '电子件'],
  ['XP 2020  XP 2020 ST款 航灯喷头连接线（短）', '电子件'],
  ['20款药箱传感器模块外管版', '电子件'],
  ['XP 2020/2020 ST款 LED尾灯（含连线）', '电子件'],
  ['XP 2020/2020 ST款 药箱感应模块', '电子件'],
  ['XP智能药箱传感器模块半成品（20L）', '电子件'],
  ['P20/P30/XP 2019/2020/2020 ST款 地形模块成品', '电子件'],
  ['XP 2020款 （后向）雷达（旗舰版专用）', '电子件'],
  ['XP 2020/2020 ST款 探照灯', '电子件'],
  ['P20/P30 2019 XP 2020/2020 ST款 FOC电调', '电子件'],
  ['XP 2020 ST款 水泵板供电线（标准版）', '电子件'],
  ['XP 2020  XP 2020 ST款  (PLD)  飞控-水泵板连接线', '电子件'],
  ['XP 2020  XP 2020 ST款 （PTS）飞控-动力板连接线', '电子件'],
  ['P20/P30 2019/2020/XP 飞控', '电子件'],
  ['XP 2020款（前向）雷达（旗舰版专用）', '电子件'],
  ['P20/P30/XP 2017/2018/2019/2020款 水泵控制板-水泵连接线', '电子件'],
  ['XP 2020 雷达集线板（旗舰版专用）', '电子件'],
  ['XP 2020款 Y型（水泵板雷达）供电线（旗舰版）', '电子件'],
  ['P10/P20/P30/XP 18/19/20款 水泵驱动板-探照灯连接线', '电子件'],
  ['20款双重反转风扇IP55', '电子件'],
  ['XP 2020/2020 ST款 探照灯转接板', '电子件'],
  ['XP2020款 （RD）雷达-HDLS模块连接线（旗舰版）', '电子件'],
  ['P20/P30/XP 2019/2020 ST款 18P014 RTK', '电子件'],
  ['20款播撒机红外对管发射板', '电子件'],
  ['20款播撒机红外对管接收板', '电子件'],
  ['20款播撒机霍尔板带壳', '电子件'],
  ['P20/P30/XP 2019/2020款 数据线', '电子件'],
]
export const xp_advance: string[][] = []
